import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {
  AvailableCarsFilterRequestBody,
  SourcingVehicleListApiArg,
  useSourcingVehicleListQuery,
} from '@dms/api/core';

type UseClassifiedsVehicleListQueriesProps = {
  filterBody: AvailableCarsFilterRequestBody | null;
  orderBy: SourcingVehicleListApiArg['orderBy'];
  currency: SourcingVehicleListApiArg['currency'];
  isFiltersOpen: boolean;
  isRealTime: boolean;
  safePage: number;
  pollingInterval: number;
  skip?: boolean;
};

export function useClassifiedsVehicleListQueries(props: UseClassifiedsVehicleListQueriesProps) {
  // Polling: automatic RTK Query polling for page 1
  const {fulfilledTimeStamp} = useSourcingVehicleListQuery(
    isNotNil(props.filterBody)
      ? {
          body: props.filterBody,
          page: 1,
          orderBy: props.orderBy,
          currency: props.currency,
          isPolling: true,
        }
      : skipToken,
    {
      skip: props.skip || props.isFiltersOpen || !props.isRealTime,
      pollingInterval: props.isRealTime ? props.pollingInterval : undefined,
      skipPollingIfUnfocused: true,
      refetchOnFocus: props.isRealTime,
      selectFromResult: ({fulfilledTimeStamp: pollingFulfilledTimeStamp}) => ({
        fulfilledTimeStamp: pollingFulfilledTimeStamp,
      }),
    }
  );

  // Infinite scroll: automatic refetching when state.page changes
  const {data, currentData, isLoading, isFetching, isError, error} = useSourcingVehicleListQuery(
    isNotNil(props.filterBody)
      ? {
          body: props.filterBody,
          page: props.safePage,
          orderBy: props.orderBy,
          currency: props.currency,
          isPolling: false,
        }
      : skipToken,
    {skip: props.skip || props.isFiltersOpen}
  );

  return {fulfilledTimeStamp, data, currentData, isLoading, isFetching, isError, error};
}
